import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';

  public my_Class = 'style1';

  modalOpened(event) {
    console.log(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts